import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { DumbFormControlComponent } from '../dumb-form-control/dumb-form-control.component';
import { DynamicControlConfiguration, DynamicFormControl, TableControlConfiguration } from '../../interfaces/dynamic-form-controls';

@Component({
  selector: 'app-table-form-control',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, DumbFormControlComponent],
  template: `
    <div *ngFor="let formGroup of formArrayContent; let i = index" class="flex w-full">
      <div *ngFor="let column of config.columns" class="pr-2 py-1">
        <app-dumb-form-control [formGroup]="formGroup" [config]="column" [showLabel]="i===0"></app-dumb-form-control>
      </div>
    </div>
    <button (click)="addRow()" role="button" type="button" class="text-sky-800 px-4 py-2 mt-4 border border-gray-300 rounded-lg block bg-slate-50">+ Lägg till artikel</button>
  `,
  styles: [
  ]
})
export class TableFormControlComponent implements OnInit {
  @Input('config') input!: DynamicControlConfiguration;
  get config(): TableControlConfiguration {
    return this.input as TableControlConfiguration;
  }

  formGroupDirective = inject(FormGroupDirective);
  formArray!: FormArray;

  ngOnInit(): void {
    this.formArray = this.formGroupDirective.control.get(this.config.name) as FormArray;
  }

  get formArrayContent(): FormGroup[] {
    const formGroups = this.formArray?.controls as FormGroup[];
    return formGroups;
  }

  addRow() {
    const newFormGroup = new FormGroup({});
    this.config.columns.forEach((column) => {
      const dynamicFormControl = new DynamicFormControl(column);
      const {name, formControl} = dynamicFormControl.toNgFormControl();
      newFormGroup.addControl(name, formControl);
    });
    this.formArray.push(newFormGroup);
  }

}
